<div class="visits" (wheel)="onScroll()">
    <div class="visits__header">
        <!-- Filter section -->
        <div class="header__section-filter header-section">
            <div class="section-filter__dropdown-wrapper input-wrapper input-wrapper_with-icon input-wrapper_with-label input-wrapper_type_select">
                <span class="input-label">הצג ביקורים עם</span>
                <select class="input dropdown__input" [(ngModel)]="classificationOption" (change)="filterDataVisit()">
                    <option *ngFor="let classification of customClassificationVisit">
                        {{ classification }}
                    </option>
                </select>
            </div>
            <div class="section-filter__dropdown-wrapper input-wrapper input-wrapper_with-icon input-wrapper_with-label input-wrapper_type_select">
                <span class="input-label">הצג סוג ביקורים</span>
                <select class="input dropdown__input" [(ngModel)]="dateclassificationOption" (change)="filterDataVisit()">
                    <option *ngFor="let dateclassification of dateClassificationVisit">
                        {{ dateclassification }}
                    </option>
                </select>
            </div>
        </div>
        <!-- Info panels section -->
        <div class="header__section-info header-section">
            <button class="header-section__more-button" (click)="togglePanelsInfo()"></button>
            <div class="header-section__panel">
                <span class="panel__header">סה"כ עד היום</span>
                <div class="panel__text">
                    <span>{{ getTotalSum() }}</span> ₪
                </div>
            </div>
            <div class="header-section__panel">
                <span class="panel__header">טיפולים</span>
                <div class="panel__text">
                    <span>{{ getServicesSum() }}</span> ₪
                </div>
            </div>
            <div class="header-section__panel">
                <span class="panel__header">מוצרים</span>
                <div class="panel__text">
                    <span>{{ getPurchaseSum() }}</span> ₪
                </div>
            </div>
            <div class="header-section__panel">
                <span class="panel__header">ביקורים</span>
                <div class="panel__text">
                    <span>{{ getCountOfVisits() }}</span>
                    <span class="panel__addition"> עד היום</span>
                </div>
            </div>
            <div class="header-section__panel">
                <span class="panel__header">ממוצע לביקור</span>
                <div class="panel__text">
                    <span>{{ getAverageVisit() }}</span> ₪
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="tmpVisits.length && (!tmpVisits[0].isDeleted || tmpVisits[0].numColor == 3)" class="visits__section section-main custom-scrollbar">
        <p-table
            class="section-main__table"
            #maintable
            [value]="tmpVisits"
            [showCurrentPageReport]="false"
            dataKey="dkey"
            (onRowExpand)="onRowExpand($event)"
            [paginator]="tmpVisits.length > 80 ? true : false"
            [rows]="80"
        >
            <!-- Strip -->
            <ng-template pTemplate="body" let-rowData let-expanded="expanded">
                <div
                    *ngIf="!rowData.isDeleted || rowData.numColor == 3"
                    class="table__row"
                    [ngClass]="{
                        table__row_blue: rowData.numColor == 1,
                        table__row_green: rowData.numColor == 2,
                        table__row_red: rowData.numColor == 3
                    }"
                >
                    <div class="row__section-info" [pRowToggler]="rowData">
                        <div class="section-info__chevron">
                            <i class="fa-regular" [ngClass]="expanded ? 'fa-chevron-down' : 'fa-chevron-left'"></i>
                        </div>
                        <div class="section-info__info-wrapper">
                            <div class="info-wrapper__main">
                                <div class="main__top main-top">
                                    <span class="main-top__text">{{ rowData.dateVisit }} יום {{ rowData.nameDay }}</span>
                                    <span *ngIf="rowData.min_fromTime" class="main-top__from-time_mobile">החל מ- {{ rowData.min_fromTime }}</span>
                                    <div class="main-top__icon-wrapper">
                                        <span *ngIf="rowData.isConfirmed" class="main-top__icon fa-regular fa-message-check"></span>
                                        <span *ngIf="rowData.is1900C" class="main-top__icon fa-regular fa-mobile-screen-button"></span>
                                    </div>
                                </div>
                                <div *ngIf="rowData.min_fromTime" class="main__bottom main-bottom">
                                    <span class="main-bottom__text">החל מ- {{ rowData.min_fromTime }}</span>
                                </div>
                            </div>
                            <div class="info-wrapper__more">
                                <div *ngIf="rowData.numColor != 3" class="more__top more-top">
                                    <span class="more-top__header">{{ rowData.countServices }} טיפולים: </span>
                                    <span class="more-top__text">{{ rowData.servicesName }}</span>
                                </div>
                                <div *ngIf="rowData.numColor != 3" class="more__bottom more-bottom">
                                    <span class="more-bottom__header">{{ rowData.countPurchase }} מוצרים: </span>
                                    <span class="more-bottom__text">{{ rowData.itemsName }}</span>
                                </div>
                                <div *ngIf="rowData.numColor == 3" class="more__cancelled">
                                    <span class="cancelled__label">הביקור בוטל</span>
                                    <span class="cancelled__text"><span>סיבת הביטול: </span>{{ rowData.cancelReasonByDate }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section-info__more-button_mobile">
                            <button
                                class="button button_icon-only more-button__menu-button"
                                (click)="toggleSubMenu($event, menu, rowData.dkey, true)"
                                [disabled]="rowData.numColor == 3"
                            >
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row__section-more">
                        <button
                            *ngIf="rowData.isHaveComments && rowData.numColor != 3"
                            class="button button_with-icon section-more__button section-more__edit-button"
                            (click)="addOrEditComment(rowData.dkey)"
                            [disabled]="isDisabled(88)"
                        >
                            <i class="fa-regular fa-pen"></i>
                            צפייה/עריכה הערות
                        </button>
                        <button
                            *ngIf="!rowData.isHaveComments && rowData.numColor != 3"
                            class="button button_with-icon section-more__button section-more__add-button"
                            (click)="addOrEditComment(rowData.dkey)"
                            [disabled]="isDisabled(88)"
                        >
                            <i class="fa-regular fa-plus"></i>
                            הוסף הערה
                        </button>
                        <span *ngIf="rowData.numColor != 3" class="section-more__label"> סה"כ {{ rowData.total_payed }} ₪ </span>
                        <button
                            class="button button_icon-only section-more__menu-button"
                            (click)="toggleSubMenu($event, menu, rowData.dkey, false)"
                            [disabled]="rowData.numColor == 3"
                        >
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        <p-menu #menu class="section-more__menu action-list" [model]="items_1" [popup]="true"></p-menu>
                    </div>
                </div>
            </ng-template>

            <!-- Substrip -->
            <ng-template pTemplate="rowexpansion" let-rowData>
                <div
                    *ngIf="!rowData.isDeleted || rowData.numColor == 3"
                    class="table__table-info-wrapper"
                    [ngClass]="{
                        'table__table-info-wrapper_blue': rowData.numColor == 1,
                        'table__table-info-wrapper_green': rowData.numColor == 2,
                        'table__table-info-wrapper_red': rowData.numColor == 3
                    }"
                >
                    <p-table class="table-info-wrapper__table-info" [value]="multi[rowData.dkey]" dataKey="dkey">
                        <ng-template pTemplate="body" let-rowData>
                            <tr
                                *ngIf="!rowData.isDeleted || rowData.numColor == 3"
                                class="table-info__row"
                                [ngClass]="{ 'table-info__row_empty': !rowData.serviceNamestr }"
                                [pSelectableRow]="rowData"
                            >
                                <td class="name-cell large-cell">
                                    <div class="name-cell__section-wrapper">
                                        <i *ngIf="rowData.isService == 1" class="name-cell__icon fa-regular fa-calendar-lines"></i>
                                        <i *ngIf="rowData.isService == 2" class="name-cell__icon fa-regular fa-jug-bottle"></i>
                                        <span class="name-cell__text">{{ rowData.serviceNamestr }}</span>
                                        <span *ngIf="rowData.subStr" class="name-cell__label">
                                            <span class="name-cell__ticket-icon"></span>
                                            {{ rowData.subStr }}
                                        </span>
                                    </div>
                                </td>
                                <td class="info-cell medium-cell">
                                    <div class="info-cell__section-wrapper">
                                        <i *ngIf="rowData.isService == 1" class="info-cell__icon fa-regular fa-clock-seven"></i>
                                        <i *ngIf="rowData.isService == 2" class="info-cell__icon fa-regular fa-tags"></i>
                                        <span *ngIf="rowData.isService == 1">{{ rowData.toTime }} - {{ rowData.fromTime }}</span>
                                        <span *ngIf="rowData.isService == 2">{{ rowData.companyName }}</span>
                                    </div>
                                </td>
                                <td class="worker-cell medium-cell">
                                    <img *ngIf="rowData.isService != 0" class="worker-cell__avatar" src="assets\img\nobody.svg" />
                                    <span class="worker-cell__text">{{ rowData.saparName }}</span>
                                </td>
                                <td *ngIf="rowData.serviceNamestr" class="name-cell_mobile">
                                    <div class="name-cell__section-wrapper_mobile">
                                        <div class="section-wrapper__main-section">
                                            <span class="main-section__name">{{ rowData.serviceNamestr }}</span>
                                            <span *ngIf="rowData.subStr" class="name-cell__label">
                                                <span class="name-cell__ticket-icon"></span>
                                                {{ rowData.subStr }}
                                            </span>
                                        </div>
                                        <div class="section-wrapper__more">
                                            <span *ngIf="rowData.isService == 1">{{ rowData.toTime }} - {{ rowData.fromTime }}</span>
                                            <span *ngIf="rowData.isService == 2">{{ rowData.companyName }}</span>
                                            <span class="more__worker-name">{{ rowData.saparName }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="price-cell large-cell">
                                    <div class="price-cell__section-wrapper">
                                        <div *ngIf="rowData.amount" class="price-cell__discount-section">
                                            <span>{{ rowData.amount }} יח</span>
                                            <i class="fa-regular fa-xmark"></i>
                                            <span>
                                                <i class="fa-regular fa-coins"></i>
                                                <span>₪{{ rowData.discountPrice }}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="rowData.isService != 0" class="price-cell__section">
                                            <i class="fa-regular fa-cash-register"></i>
                                            <span>₪{{ rowData.pricePerchase }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td *ngIf="rowData.isService == 1" class="row__more-cell small-cell">
                                    <button
                                        class="more-cell__button more-cell__button_mobile button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, menu, rowData.dkey, rowData.id, true, 1)"
                                        [disabled]="isDisabled(83) || rowData.numColor == 3"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <button
                                        class="more-cell__button button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, menu, rowData.dkey, rowData.id, false, 1)"
                                        [disabled]="isDisabled(83) || rowData.numColor == 3"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <p-menu #menu class="more-cell__menu action-list" [model]="items_3" [popup]="true"></p-menu>
                                </td>
                                <td *ngIf="rowData.isService == 2" class="row__more-cell small-cell">
                                    <button
                                        class="more-cell__button_mobile button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, menu, rowData.dkey, rowData.id, true, 2)"
                                        [disabled]="isDisabled(84) || rowData.numColor == 3"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <button
                                        class="more-cell__button button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, menu, rowData.dkey, rowData.id, false, 2)"
                                        [disabled]="isDisabled(84) || rowData.numColor == 3"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <p-menu #menu class="more-cell__menu action-list" [model]="items_2" [popup]="true"></p-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </ng-template>
        </p-table>
        <button
            *ngIf="visit.total.showMoreButton && this.dateclassificationOption == 'הכל' && this.classificationOption == 'הכל'"
            class="section-main__more-button button button_theme_main"
            (click)="moreStripsButton()"
        >
            טען עוד
        </button>
    </div>

    <!-- Empty visits list -->
    <div *ngIf="!tmpVisits.length || tmpVisits[0].isDeleted" class="visits__section_empty section-empty">
        <span class="section-empty__header">אין עדיין ביקורים ללקוח/ה</span>
        <span class="section-empty__text">לשונית זאת תתמלא אוטומטית כשיתווספו טיפולים ביומן</span>
        <span class="section-empty__image"></span>
    </div>
</div>

<!-- Mobile info panels -->
<div *ngIf="isPanelsInfoOpened" class="panel-wrapper_mobile">
    <div class="panel-wrapper__background" (click)="togglePanelsInfo()"></div>
    <div class="panel-wrapper__main-section">
        <span class="main-section__header-name">סה״כ ביקורים והכנסות של {{ customerFl }}</span>
        <div class="main-section__panel panel-total">
            <span class="panel__header">סה"כ עד היום</span>
            <div class="panel__text">
                <span>{{ visit.total.total_sum }}</span> ₪
            </div>
        </div>
        <div class="main-section__panel">
            <span class="panel__header">טיפולים</span>
            <div class="panel__text">
                <span>{{ visit.total.services_sum }}</span> ₪
            </div>
        </div>
        <div class="main-section__panel">
            <span class="panel__header">מוצרים</span>
            <div class="panel__text">
                <span>{{ visit.total.purchase_sum }}</span> ₪
            </div>
        </div>
        <div class="main-section__panel">
            <span class="panel__header">ביקורים</span>
            <div class="panel__text">
                <span>{{ visit.total.countOfVisits }}</span>
                <span class="panel__addition">עד היום</span>
            </div>
        </div>
        <div class="main-section__panel">
            <span class="panel__header">ממוצע לביקור</span>
            <div class="panel__text">
                <span>{{ visit.total.averageVisit }}</span> ₪
            </div>
        </div>
    </div>
</div>

<!-- Modals -->

<!-- Comment editing modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isEditComment }"
    styleClass="modal comment-modal"
    [(visible)]="isEditComment"
    header="הערה חדשה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="comment-modal__textarea input-wrapper input-wrapper_type_textarea input-wrapper_with-label">
        <span class="input-label">הערה לביקור</span>
        <textarea
            class="input textarea__input custom-scrollbar"
            [(ngModel)]="openedComment"
            placeholder="הוסף הערות..."
            autocomplete="off"
        ></textarea>
    </div>
    <div class="comment-modal__button-wrapper button-wrapper modal__footer">
        <button class="button button_theme_gray-line" (click)="cancelButton()">בטל</button>
        <button class="button button_theme_main" (click)="saveComment()">שמירה</button>
    </div>
</p-dialog>

<!-- Purchase editing modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isEditPurchase }"
    styleClass="modal purchase-modal"
    [(visible)]="isEditPurchase"
    header="עדכון מכירה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="purchase-modal__main-section">
        <div class="main-section__name-section">
            <div class="name-section__purchase-icon"></div>
            <div class="name-section__purchase-info">
                <span class="purchase-info__name">{{ purchaseName }}</span>
                <span class="purchase-info__description">ביופור</span>
            </div>
        </div>
        <div class="main-section__info-section">
            <div class="info-section__worker-wrapper_mobile input-wrapper input-wrapper_with-label input-wrapper_type_select input-wrapper_with-icon">
                <span class="input-label">מטפל שמכר</span>
                <select class="input dropdown__input" [(ngModel)]="purchaseSaparName">
                    <option *ngFor="let worker of workers">
                        {{ worker.saparName }}
                    </option>
                </select>
            </div>
            <div class="input-wrapper input-wrapper_with-label">
                <span class="input-label">מחירון</span>
                <span class="purchase-current">₪{{ purchaseClientPrice }}</span>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper_type_signature">
                <span class="input-label">הנחה</span>
                <div class="signature">
                    <div class="signature-value">%</div>
                    <input class="input" [(ngModel)]="purchaseDiscountPercent" (input)="onInputCalculation('purchase', 'discount', $event.target)" />
                </div>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper_type_signature">
                <span class="input-label">לתשלום</span>
                <div class="signature">
                    <div class="signature-value">₪</div>
                    <input class="input" [(ngModel)]="purchaseDiscountPrice" (input)="onInputCalculation('purchase', 'price', $event.target)" />
                </div>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                <span class="input-label">כמות מוצרים</span>
                <div class="range">
                    <button class="range__button range__button_minus" (click)="decrementAmount()">
                        <i class="fa-regular fa-minus"></i>
                    </button>
                    <input
                        class="input"
                        [(ngModel)]="purchaseAmount"
                        (focus)="onRangeFocus($event.target)"
                        (input)="onInputCalculation('purchase', 'amount', $event.target)"
                    />
                    <button class="range__button range__button_plus" (click)="incrementAmount()">
                        <i class="fa-regular fa-plus"></i>
                    </button>
                </div>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper__total-price">
                <span class="input-label">סה״כ</span>
                <span class="purchase-total"><span class="purchase-total__addition">₪</span>{{ purchaseTotal }}</span>
            </div>
        </div>
    </div>
    <div class="purchase-modal__footer modal__footer">
        <div class="footer__worker-wrapper input-wrapper input-wrapper_with-label input-wrapper_type_select input-wrapper_with-icon">
            <span class="input-label">מטפל שמכר</span>
            <select class="input dropdown__input" [(ngModel)]="purchaseSaparName">
                <option *ngFor="let worker of workers">
                    {{ worker.saparName }}
                </option>
            </select>
        </div>
        <div class="footer__button-wrapper button-wrapper">
            <button class="button button_theme_gray-line" (click)="cancelButton()">בטל</button>
            <button class="button button_theme_main" (click)="saveEditedPurchase()">שמירה</button>
        </div>
    </div>
</p-dialog>

<!-- Service editing modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isEditService }"
    styleClass="modal service-modal"
    [(visible)]="isEditService"
    header="עדכון מכירה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="service-modal__main-section">
        <div class="main-section__name-section">
            <div class="name-section__service-icon"></div>
            <div class="name-section__service-info">
                <span class="service-info__name">{{ serviceName }}</span>
                <span class="service-info__description">מטפל/ת: {{ serviceSaparName }}</span>
            </div>
        </div>
        <div class="main-section__info-section">
            <div class="input-wrapper input-wrapper_with-label">
                <span class="input-label">מחירון</span>
                <span class="service-current">₪{{ serviceClientPrice }}</span>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper_type_signature">
                <span class="input-label">הנחה</span>
                <div class="signature">
                    <div class="signature-value">%</div>
                    <input class="input" [(ngModel)]="serviceDiscountPercent" (input)="onInputCalculation('service', 'discount', $event.target)" />
                </div>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper_type_signature">
                <span class="input-label">לתשלום</span>
                <div class="signature">
                    <div class="signature-value">₪</div>
                    <input class="input" [(ngModel)]="serviceDiscountPrice" (input)="onInputCalculation('service', 'price', $event.target)" />
                </div>
            </div>
            <div class="input-wrapper input-wrapper_with-label input-wrapper__total-price">
                <span class="input-label">סה״כ</span>
                <span class="service-total"><span class="service-total__addition">₪</span>{{ serviceTotal }}</span>
            </div>
        </div>
    </div>
    <div class="service-modal__footer modal__footer">
        <div class="footer__button-wrapper button-wrapper">
            <button class="button button_theme_gray-line" (click)="cancelButton()">בטל</button>
            <button class="button button_theme_main" (click)="saveEditedService()">שמירה</button>
        </div>
    </div>
</p-dialog>

<!-- Mobile visit menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isVisitMenuOpened }"
    styleClass="modal modal_type_menu modal_visits-menu"
    [(visible)]="isVisitMenuOpened"
    header="פעולות נוספות לביקור"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items_1"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<!-- Mobile purchase menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isPurchaseMenuOpened }"
    styleClass="modal modal_type_menu modal_purchases-menu"
    [(visible)]="isPurchaseMenuOpened"
    header="פעולות נוספות למוצר"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items_2"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<!-- Mobile service menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isServiceMenuOpened }"
    styleClass="modal modal_type_menu modal_services-menu"
    [(visible)]="isServiceMenuOpened"
    header="פעולות נוספות לטיפול"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items_3"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<!-- Purchase deleting modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isDeletingPurchase }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isDeletingPurchase"
    header="מחיקה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <span class="modal__text">האם אתם בטוחים במחיקת מוצר?</span>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">ביטול</button>
        <button class="button button_size_small button_theme_main" (click)="deletePurchase()">מחיקה</button>
    </div>
</p-dialog>

<p-messages class="messages"></p-messages>

<div
    appHostListenerBeforeUnload
    #hostListenerBeforeUnload="hostListenerBeforeUnload"
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="visits"
></div>

<!-- <div class="container-fluid">
    <p>&nbsp;</p>
	<div class="row">
	
	</div>
	<div class="row">
		<div class="col-md-12">
			<div class="row">
				<div style="text-align: justify;" class="col-md-2">
                    <select class="input dropdown__input" [(ngModel)]="classificationOption" (change)="filterDataVisit()">
                        <option *ngFor="let classification of customClassificationVisit">
                            {{ classification }}
                        </option>
                    </select>
				</div>
				<div style="text-align: right;" class="col-md-2">
                    <select class="input dropdown__input" [(ngModel)]="dateclassificationOption" (change)="filterDataVisit()">
                        <option *ngFor="let dateclassification of dateClassificationVisit">
                            {{ dateclassification }}
                        </option>
                    </select>
				</div>
				<div class="col-md-1">
				</div>
				<div style="text-align: left;" class="col-md-2">
                   <a class="nav-link btn btn-light text-wrap" style="width: 8rem;" href="#">סה"כ עד היום <span class="badge badge-light">{{getTotalSum()}}
                    <i class="fa-solid fa-shekel-sign fa-2xs"></i>
                   </span></a>                   
				</div>
				<div class="col-md-1">
                    <a class="nav-link btn btn-light" href="#">טיפולים<span class="badge badge-light">{{getServicesSum()}}
                        <i class="fa-solid fa-shekel-sign fa-2xs"></i>                        
                    </span></a>
				</div>
				<div class="col-md-1">
                    <a class="nav-link btn btn-light" href="#">מוצרים<span class="badge badge-light">{{getPurchaseSum()}}
                        <i class="fa-solid fa-shekel-sign fa-2xs"></i>                        
                    </span></a>
				</div>
				<div class="col-md-2">
                    <a class="nav-link btn btn-light text-wrap" style="width: 9rem;" href="#">ביקורים עד היום<span class="badge badge-light">{{getCountOfVisits()}}</span></a>
				</div>
				<div class="col-md-1">
                    <a class="nav-link btn btn-light" style="width: 8rem;" href="#">ממוצע לביקור<span class="badge badge-light">{{getAverageVisit()}}
                        <i class="fa-solid fa-shekel-sign fa-2xs"></i>                        
                    </span></a>                    
				</div>
			</div>
		</div>
	</div>


</div>

<p>&nbsp;</p>


<p-table class="main__table"  #maintable [value]="visits" [paginator]="true" [rows]="7" [showCurrentPageReport]="false" dataKey="dkey"  (onRowExpand)="onRowExpand($event)">

    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">

        <p>&nbsp;</p>
        <div class="container-fluid">
            <div class="row" [ngClass]="{'table-primary':rowData.numColor===1 ,'table-success':rowData.numColor===2,'table-danger': rowData.numColor===3}">
                <div class="col-md-1">
                    <a href="#" [pRowToggler]="rowData">
                        <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-left'"></i>
                    </a>
                </div>
                <div class="col-md-2 float-end">
                    <span class="info__name">{{ rowData.dateVisit }}  יום {{rowData.nameDay}} </span>
                </div>
                 <div class="col-md-1">
                    <div class="row">
                        <div class="col-md-6">
                            <i *ngIf="rowData.isConfirmed" class="fa-solid fa-check"></i>
                        </div>
                        <div class="col-md-6">
                            <i *ngIf="rowData.is1900C" class="fa-solid fa-mobile-screen"></i>
                        </div>
                    </div>
                  
                </div>

               <div class="col-md-4">
                   <div *ngIf="rowData.numColor!=3" class="float-end">
                    {{ rowData.countServices }} טיפולים:  {{ rowData.servicesName }}
                    </div>
                   <div *ngIf="rowData.numColor!=3" class="float-end">
                     {{ rowData.countPurchas }} מוצרים:  {{ rowData.itemsName }} 
                   </div>
                   <span *ngIf="rowData.numColor==3" class="badge badge-pill badge-danger pill-large" style="font-size: 14px;">
                    הביקור בוטל
                   </span>    
                    <span  *ngIf="rowData.numColor==3">
                        &nbsp;סיבת הביטול: {{ rowData.cancelReasonByDate }}
                    </span>


                </div>
         
                <div class="col-md-2">
                    <button *ngIf="rowData.isHaveComments && rowData.numColor!=3" type="button" class="btn btn-info btn-rounded btn-icon btn-comment" (click)="selectVisitWithButton(rowData.dateVisit)">
                        <i class="fa-regular fa-pencil"></i>
                        צפייה/עריכה הערות
                     </button>
                     <button *ngIf="!rowData.isHaveComments && rowData.numColor!=3" type="button" class="btn btn-info btn-rounded btn-icon btn-nocomment" (click)="selectVisitWithButton(rowData.dateVisit)">
                        <i class="fa-regular fa-plus"></i>
                        הוסף הערה
                     </button>
                 
                </div>
                <div class="col-md-1">
                      <span *ngIf="rowData.numColor===2" class="badge badge-pill badge-warning pill-large" style="font-size: 14px;">
                       סה"כ {{ rowData.total_payed }}
                       <i class="fa-solid fa-shekel-sign fa-2xs"></i>
                      </span>    
                      <span *ngIf="rowData.numColor===1" class="badge badge-pill badge-primary pill-large" style="font-size: 14px;">
                        סה"כ {{ rowData.total_payed }}
                        <i class="fa-solid fa-shekel-sign fa-2xs"></i>
                       </span>    
                       
                </div>

                <div class="col-md-1">
                   <button class="more-cell__button button button_icon-only" (click)="toggleSubMenu($event, menu, rowData.dateVisit, rowData.numColor,false)">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                   <p-menu #menu class="more-cell__menu action-list" [model]="items_1" [popup]="true"></p-menu> 
              </div>



             </div>
        </div>


    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
        <p-table class="body__table" [columns]="cols" [value]="multi[rowData.dateVisit+'!'+rowData.numColor]" [(selection)]="selected" dataKey="dkey">
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="table__row" [pSelectableRow]="rowData">
                    <td  class="small-cell">
                      <i *ngIf="rowData.isService==1" class="fa-light fa-grill-hot"></i> 
                      <i *ngIf="rowData.isService==2" class="fa-light fa-ice-cream"></i>
                    </td>
                    <td *ngFor="let col of columns" [ngClass]="col.headerClass">
                     <span>
                        <i *ngIf="col.field=='icon' && rowData.isService!=0 && rowData.isService==1" class="fa-regular fa-copyright"></i>
                        <i *ngIf="col.field=='icon' && rowData.isService!=0 && rowData.isService==2" class="fa-solid fa-copyright"></i>
                        {{ rowData[col.field] }}
                    </span>
                    </td>
                    <td  class="small-cell">
                        <img *ngIf="rowData.isService!=0" src="assets\img\nobody.svg" alt="SVG Icon"/> 
                    </td>

                    <td  class="small-cell">
                        {{ rowData.saparName }}
                    </td>
                    
                    <td  class="medium-cell">
                        <span *ngIf="rowData.isService==2 &&  rowData.amount!='' ">
                            {{ rowData.amount }} יח
                            <i class="fa-light fa-xmark"></i>&nbsp;
                            <i class="fa-light fa-coins"></i>&nbsp;
                            {{ rowData.discountPrice }}
                            <i *ngIf="rowData.isService!=0" class="fa-solid fa-shekel-sign fa-2xs"></i>                            
                        </span>
                    </td>

                    <td  class="small-cell">
                        <i *ngIf="rowData.isService!=0" class="fa-light fa-gift"></i>
                         {{ rowData.pricePerchase }}
                         <i *ngIf="rowData.isService!=0" class="fa-solid fa-shekel-sign fa-2xs"></i>                         
                    </td>

                    <td  *ngIf="rowData.isService===1" class="row__more-cell small-cell">
                        <button class="more-cell__button button button_icon-only" (click)="toggleSubMenuDetails($event, menu, rowData.dateVisit, rowData.id)">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                         <p-menu  #menu class="more-cell__menu action-list" [model]="items_3" [popup]="true"></p-menu> 
                         
                    </td>
                    <td  *ngIf="rowData.isService===2" class="row__more-cell small-cell">
                        <button class="more-cell__button button button_icon-only" (click)="toggleSubMenuDetails($event, menu, rowData.dateVisit, rowData.id)">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                         <p-menu  #menu class="more-cell__menu action-list" [model]="items_2" [popup]="true"></p-menu> 
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</p-table>

<div class="container-fluid">
	<div class="row">
		<div class="col-md-6">
            <button type="button" (click)="saveVisitsStrips()" class="btn btn-success">save strips</button>
		</div>
		<div class="col-md-6">
            <button type="button" (click)="saveVisitsSubStrips()" class="btn btn-success">save substrips</button>
       </div>

	</div>
</div> -->
